import type { TileType } from '../../base/package/api/package/gaming/gaming-domain';

/**
 * Intrinsic pixel dimensions per tile type.
 *
 * MUST stay in sync with `ui-game-tile-sizes.css` — that stylesheet
 * is the render-time source of truth for the shadow DOM; this map is
 * the build-time source for layout math (e.g. reserving carousel
 * height for `content-visibility` lanes). There is no build bridge
 * between the two, so update both when a tile dimension changes.
 */
export const TILE_SIZE_PX: Record<TileType, { width: number; height: number }> = {
  p1: { width: 109, height: 156 },
  p2: { width: 156, height: 280 },
  p3: { width: 80, height: 116 },
  p4: { width: 67.37, height: 96 },
  p5: { width: 30, height: 43 },
  l1: { width: 327, height: 192 },
};
